import { render, staticRenderFns } from "./UploadImageDirect.vue?vue&type=template&id=331f152e&scoped=true&"
import script from "./UploadImageDirect.vue?vue&type=script&lang=js&"
export * from "./UploadImageDirect.vue?vue&type=script&lang=js&"
import style0 from "./UploadImageDirect.vue?vue&type=style&index=0&id=331f152e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331f152e",
  null
  
)

export default component.exports